import { createContext } from "react";

export const initialGiftCoachingContext = {
    showGiftCoachingModal: () => {},
    canDoReferrals: false,
};
export const GiftCoachingContext = createContext(initialGiftCoachingContext);
